import { Container } from '../../../odie';

import { PipeBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image: 'pipe/block.pipe.png',
};

/*
    pipe block view
*/
export class PipeBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: PipeBlockProps) {
    // create base view
    super();
    this.addChild(new FitWidthBlockSprite(manifest.image, props));
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [manifest.image];
  }
}
